function handleBubbleInjection(e) {
    const desktopBubble = document.querySelector('[data-desktop-bubble]');
    const mobileBubble = document.querySelector('[data-mobile-bubble]');

    if (!desktopBubble || !mobileBubble) return;

    if (e.matches) {
        mobileBubble.innerHTML = '';
    } else {
        mobileBubble.innerHTML = desktopBubble.innerHTML;
    }
}

document.addEventListener('DOMContentLoaded', () => {
    const mediaQuery = window.matchMedia('(min-width: 990px)');
    handleBubbleInjection(mediaQuery);
    mediaQuery.addEventListener('change', handleBubbleInjection);
});
